import VueRouter from 'vue-router'
import main from './main'
import menu from './menu'

const routes = [...main, menu]
const router = new VueRouter({routes})

router.beforeEach(function (to, from, next) {
	if (to.query.modal == 'prevencao') {
		sessionStorage.setItem('MODAL_PREVENCAO', true)
	}

	if (!from) {
		next('load')
	}

	if (to.path === '/' || to.path === '') {
		next('load')
	}

	if (to.path.includes('/indice-documento/visualizar') && to.params) {
		sessionStorage.setItem('ID_INDICE_DOCUMENTO', to.params.id)
	}

	if (to.path.includes('/reseta-senha')) {
		next()
	} else if (to.path.includes('/valida-documento')) {
		next()
	} else if (to.path.includes('/suprimento-recebimento')) {
		next()
	}

	// se não tiver indo para login
	else if (!to.path.includes('/login')) {
		if (!to.path.includes('/load')) {
			if ($sessao.logado()) {
				if (to) {
					if (to.name === 'inicio') {
						next()
					} else {
						let currentRoute = {}

						for (let routeData of routes) {
							currentRoute =
								routeData.path === '/'
									? routeData.children.find(
											(childRouteData) => childRouteData.name === to.name
									  )
									: {}
						}

						if (currentRoute.modulo == 0) {
							if (currentRoute.privilegio == 0) {
								next()
							} else {
								if (!$sessao.getPrivilegio(currentRoute.privilegio)) {
									next('inicio')
								} else {
									next()
								}
							}
						} else {
							if (!$cliente.getModulo(currentRoute.modulo)) {
								next('inicio')
							} else if (currentRoute.privilegio == 0) {
								next()
							} else if (!$sessao.getPrivilegio(currentRoute.privilegio)) {
								next('inicio')
							} else {
								next()
							}
						}
					}
				} else {
					next('inicio')
				}
			} else {
				next('load')
			}
		} else {
			next()
		}
	} else {
		// se tiver indo para o login e nao tiver o cliente volta pra o load
		if (!$cliente.get('id')) {
			next('load')
		} else {
			next() // vai pro login
		}
	}
})

export default router
// Rotas e coisas que ainda faltam serem utilizadas, essas coisas estão comentadas ou não são usadas no routers.js:
//let Escala = './modules/layout/escala/alagoas/main'
//let RelatorioEmbarqueDefault = './modules/layout/relatorio/embarque/cm-bahia/main'
//let RelatorioApoioSoloDefault = './modules/layout/relatorio/apoio-solo/cm-bahia/main'

// COMPONENTES CUSTOMIZADOS PARA A AMERICA SUL
// if ($cliente.get('id') == '21') {
// 	Solicitacao = './modules/layout/solicitacao/americasul/main'
// 	OrdemMissao = './modules/layout/ordem-missao/americasul/main'
// 	Despacho = './modules/layout/despacho/americasul/main'
// 	QuadroAtividades = './modules/layout/quadro-atividades/americasul/main'
// }

// let ValidarSolicitacao = './modules/externo/validar-solicitacao/main'

// id do ibama
// if (clientId === 5) {
// 	Escala = 'modules/layout/escala/ibama/main'
// }

// ID DA AEROTERRA
// if (clientId === 13 || clientId === 21) {
// 	Escala = 'modules/layout/escala/aeroterra/main'
// }

//import SolicitacaoPublic from './modules/externo/solicitacao/main.vue'

// CONTRATOS SBH
// {
// 	modulo: 18,
// 	privilegio: 1,
// 	path: 'contratos-abastecimento',
// 	component: loadView(CadastroContratosAbastecimento),
// 	name: 'contratos-abastecimento',
// },

// { modulo: 6, privilegio: 65, path: '/manutencao-solicitacao', component : SolicitacaoManutencao, name: 'manutencao-solicitacao' },
// { modulo: 6, privilegio: 42, path: '/inspecao', component : Inspecao, name: 'inspecao' },

// { modulo: 6, privilegio: 48, path: '/cadastro-de-grupo', component: GrupoInspecao, name: 'cadastro-de-grupo'},
// { modulo: 6, privilegio: 43, path: '/plano-de-manutencao', component : PlanodeManutencao, name: 'plano-de-manutencao' },
// { modulo: 6, privilegio: 87, path: '/natureza-de-manutencao', component: NaturezaManutencao, name: 'natureza-de-manutencao'},
